// extracted by mini-css-extract-plugin
module.exports = {"headText":"dialogBox_headText__1WFsy","copyBlock":"dialogBox_copyBlock__1xMRc","successCopy":"dialogBox_successCopy__3g9LO"};